import { render, staticRenderFns } from "./ContractorCard.vue?vue&type=template&id=23273876&scoped=true"
import script from "./ContractorCard.vue?vue&type=script&lang=js"
export * from "./ContractorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23273876",
  null
  
)

export default component.exports